/**
 * Route for `indoleads-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IndoleadsIntegrationPage } from "../features/indoleads-integration/IndoleadsIntegrationPage";

export const indoleadsIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/indoleads-integration",
	component: IndoleadsIntegrationPage,
});

export default indoleadsIntegrationRoute;
